<template>
    <div class="app">
        <!-- 搜索栏 -->
        <div class="search-bar">
            <input
                    type="text"
                    :placeholder="$t('l.search')"
                    v-model="searchKeyword"
                    class="search-input"
            />
            <span class="search-icon" @click="handleSearch">🔍</span>
        </div>

        <!-- 文档列表 -->
        <div class="fault-list">
            <!-- 加载状态 -->
            <div v-if="loading" class="loading">
                {{$t('l.hint46')}}
            </div>

            <!-- 无数据状态 -->
            <div v-else-if="this.faults.length === 0" class="no-data">
                {{$t('l.no_datas')}}
            </div>

            <!-- 文档列表 -->
            <div v-else>
                <div
                        v-for="(fault, index) in faults"
                        :key="index"
                        class="fault-item"
                >
                    <div class="fault-info">
                        <div class="fault-title">{{$t('l.err_code')}}：</div>
                        <div>{{fault.err_code}}</div>
                        <div class="fault-title">{{$t('l.err_child')}}：</div>
                        <div v-html="fault.err_child"></div>
                        <div class="fault-title">{{$t('l.err_solution')}}：</div>
                        <div v-html="fault.err_solution"></div>
                        <div class="fault-title">{{$t('l.err_meaning')}}：</div>
                        <div v-html="fault.err_meaning"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 分页控件 -->
        <div class="pagination">
            <button
                    class="pagination-btn"
                    :disabled="currentPage === 1"
                    @click="prevPage"
            >
                {{$t('l.previous_page')}}
            </button>
            <span class="pagination-info">
        {{ currentPage }} / {{ totalPages }}
      </span>
            <button
                    class="pagination-btn"
                    :disabled="currentPage === totalPages"
                    @click="nextPage"
            >
                {{$t('l.next_page')}}
            </button>
        </div>
    </div>
</template>

<script>
    import util from '@/libs/util.js';

    export default {
        name: "page-fault",
        data() {
            return {
                loading: false,
                searchKeyword: '',
                faults: [],
                currentPage: 1,
                totalPages: 1,
                pageSize: 10,
            }
        },
        methods: {
            fetchFaults() {
                this.loading = true;
                util.ajax.post('/wx/qr/getFaultList', {
                    params: {
                        searchKeyword: this.searchKeyword,
                        currentPage: this.currentPage,
                        pageSize: this.pageSize
                    }
                }).then((res) => {
                    this.loading = false;
                    if (res.code == 0) {
                        this.totalPages = res.data.last_page ? res.data.last_page : 1;
                        this.faults = res.data.data;
                    }
                }).catch(e => {
                    this.loading = false;
                });
            },
            handleSearch() {
                this.currentPage = 1;
                this.fetchFaults();
            },
            prevPage() {
                if (this.currentPage > 1) {
                    this.currentPage--;
                    this.fetchFaults();
                }
            },
            nextPage() {
                if (this.currentPage < this.totalPages) {
                    this.currentPage++;
                    this.fetchFaults();
                }
            },
        },
        mounted: function () {
            this.fetchFaults();
        },
    }
</script>


<style scoped>
    .app {
        height: 100%;
        width: 100%;
        padding: 15px;
        background-image: url("../../../public/images/wx/qr_top.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-color: #f5f5f5;
        box-sizing: border-box;
    }

    /* 切换语言 */
    .language {
        cursor: pointer;
        font-size: 18px;
        font-weight: bold;
        color: white;
        width: 100%;
        text-align: end;
        margin-top: -5px;
        margin-bottom: 5px;
    }

    /* 搜索栏 */
    .search-bar {
        position: relative;
        margin-bottom: 15px;
    }

    .search-input {
        width: 100%;
        padding: 10px 20px 10px 10px;
        border: 1px solid #ddd;
        border-radius: 20px;
        font-size: 14px;
        outline: none;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .search-icon {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 16px;
        color: #999;
    }

    /* 故障码列表 */
    .fault-list {
        background-color: #fff;
        border-radius: 8px;
        padding: 0 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        margin-bottom: 15px;
        height: calc(100% - 120px);
    }

    /* 加载状态 */
    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        font-size: 14px;
        color: #666;
    }

    .loading::after {
        content: '';
        width: 20px;
        height: 20px;
        margin-left: 10px;
        border: 2px solid #f3f3f3;
        border-top: 2px solid #4CAF50;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    /* 无数据状态 */
    .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        font-size: 14px;
        color: #999;
    }

    .fault-item {
        display: flex;
        gap: 12px;
        padding: 10px;
        border-bottom: 1px solid #f0f0f0;
        transition: all 0.3s ease;
    }

    .fault-item:hover {
        background-color: #f9f9f9;
    }

    .fault-item:last-child {
        border-bottom: none;
    }

    .fault-info {
        flex: 1;
        min-width: 0;
    }

    .fault-title {
        font-size: 12px;
        font-weight: bold;
        color: #333;
        margin-bottom: 8px;
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    /* 分页控件 */
    .pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .pagination-btn {
        padding: 3px 15px;
        border: 1px solid #ddd;
        border-radius: 4px;
        background-color: #fff;
        font-size: 12px;
        color: #333;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .pagination-btn:hover:not(:disabled) {
        background-color: #f0f0f0;
    }

    .pagination-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .pagination-info {
        font-size: 14px;
        color: #666;
        margin: 0 15px;
    }
</style>